import clsx from 'clsx'
import type { MouseEvent } from 'react'
import PlayerPauseFilledIcon from '@/assets/player-pause-filled.svg?react'
import PlayerPlayFilledIcon from '@/assets/player-play-filled.svg?react'
import VolumeIcon from '@/assets/volume.svg?react'
import VolumeOffIcon from '@/assets/volume-off.svg?react'
import styles from './StoryMedia.module.css'

export interface StoryVideoControlsProps {
	isPlaying: boolean
	isMuted: boolean
	onTogglePlayback?: () => void
	onToggleMuted?: () => void
}

export default function StoryVideoControls({
	isPlaying,
	isMuted,
	onTogglePlayback,
	onToggleMuted,
}: StoryVideoControlsProps) {
	const handlePlaybackClick = (event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation()
		onTogglePlayback?.()
	}

	const handleMutedClick = (event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation()
		onToggleMuted?.()
	}

	return (
		<>
			<button
				type="button"
				className={clsx(styles.playbackButton, isPlaying && styles.playingButton)}
				aria-label={isPlaying ? '暂停视频日记' : '播放视频日记'}
				onClick={handlePlaybackClick}
			>
				{isPlaying ? (
					<PlayerPauseFilledIcon aria-hidden="true" />
				) : (
					<PlayerPlayFilledIcon aria-hidden="true" />
				)}
			</button>
			<button
				type="button"
				className={styles.mutedButton}
				aria-label={isMuted ? '开启视频声音' : '静音视频'}
				onClick={handleMutedClick}
			>
				{isMuted ? <VolumeOffIcon aria-hidden="true" /> : <VolumeIcon aria-hidden="true" />}
			</button>
		</>
	)
}
